function controlfun(el) {
  const container = el.closest('.video-container');
  if (!container) return;

  const video = container.querySelector('video');
  if (!video) return;

  // Toggle play/pause
  if (video.paused) {
    video.play();
    el.classList.remove('active');
  } else {
    video.pause();
    el.classList.add('active');
  }
}

function mutedfun(el) {
  const container = el.closest('.video-container');
  if (!container) return;

  const video = container.querySelector('video');
  if (!video) return;

  // Toggle mute/unmute
  if (video.muted) {
    video.muted = false;
    el.classList.add('active');
  } else {
    video.muted = true;
    el.classList.remove('active');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  if (typeof Swiper === 'undefined') return;

  const videoSwiper = document.querySelector('.video-swiper');
  if (!videoSwiper) return;

  new Swiper('.video-swiper', {
    slidesPerView: 1.3,
    centeredSlides: true,
    spaceBetween: 15,
    loop: true,
    pagination: {
      el: '.video-section .swiper-pagination',
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 4.8,
        spaceBetween: 15,
      },
    },
    on: {
      init: function () {
        // Play video in the active slide automatically
        const activeSlide = this.slides[this.activeIndex];
        const videoEl = activeSlide?.querySelector('video');
        const controlBtn = activeSlide?.querySelector('.span_pause');

        if (videoEl) {
          videoEl.play();
          if (controlBtn) controlBtn.classList.remove('active');
        }

        // Attach click to slides for navigation
        this.slides.forEach((slide) => {
          slide.addEventListener('click', (e) => {
            // Ignore clicks on controls or links
            if (e.target.closest('a, button, .span_muted, .span_pause')) return;

            const realIdxAttr = slide.getAttribute('data-swiper-slide-index') || slide.dataset.swiperSlideIndex;
            const targetIndex = realIdxAttr != null ? parseInt(realIdxAttr, 10) : Array.from(this.slides).indexOf(slide);

            this.slideToLoop(targetIndex, 500);
          });
        });
      },

      slideChange: function () {
        // Pause all videos first
        this.slides.forEach((slide) => {
          const vid = slide.querySelector('video');
          const pauseBtn = slide.querySelector('.span_pause');
          if (vid) vid.pause();
          if (pauseBtn) pauseBtn.classList.add('active');
        });

        // Play video on active slide
        const activeSlide = this.slides[this.activeIndex];
        const activeVideo = activeSlide?.querySelector('video');
        const controlBtn = activeSlide?.querySelector('.span_pause');

        if (activeVideo) {
          activeVideo.currentTime = 0;
          activeVideo.play();
          if (controlBtn) controlBtn.classList.remove('active');
        }
      },
    },
  });
});
